export default __webpack_public_path__ + "images/43f30f48a00022f0dd1354a57b833116-Eventbrite_NYE_HomepageA_1919x543.webp";